import { PlacementErrorType } from '@frontend/sports/types/betslip';

import { stringToNullableNumber } from '../error-convert-helpers';
import { UserError } from './user-error';

/**
 * Corresponding event types are:
 * liveMaxBetExceeded, liveMaxBetExceededNoEvent
 */
export class ElToroLiveMaxBet extends UserError {
    constructor(limitPoolSize: number | undefined, eventId: string | undefined) {
        super();
        this.limitPoolSize = limitPoolSize == null ? null : limitPoolSize;
        this.eventId = stringToNullableNumber(eventId);
        this.type = PlacementErrorType.LiveMaxBetExceeded;
    }

    limitPoolSize: number | null;
    eventId: number | null;
}
